import { render } from "./AcceptsModal2.vue?vue&type=template&id=cb67cbd0&scoped=true"
import script from "./AcceptsModal2.vue?vue&type=script&lang=js"
export * from "./AcceptsModal2.vue?vue&type=script&lang=js"

import "./AcceptsModal2.vue?vue&type=style&index=0&id=cb67cbd0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb67cbd0"]])

export default __exports__